import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { InputOtp } from 'primereact/inputotp';
import { verifyPasswordResetOTP, forgotPassword } from '../services/authService';
import Navbar from "../components/landingpage/sections/Navbar";

const ResetOtp2 = (props) => {
    const [otp, setOtp] = useState("");
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [timer, setTimer] = useState(600);
    const [canResend, setCanResend] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Get email from localStorage with celebrity identifier
        const savedEmail = localStorage.getItem('celebrityResetPasswordEmail');
        if (!savedEmail) {
            navigate('/forgot-password2');
            return;
        }
        setEmail(savedEmail);

        // Start countdown timer
        const countdown = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(countdown);
                    setCanResend(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(countdown);
    }, [navigate]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (otp.length !== 6) {
            setError("Please enter a 6-digit OTP");
            return;
        }

        setIsLoading(true);
        setError("");

        try {
            const response = await verifyPasswordResetOTP(email, otp);

            if (response.success) {
                setSuccess("OTP verified successfully");
                setTimeout(() => {
                    navigate('/reset-password2');
                }, 1500);
            }
        } catch (error) {
            setError(error.message || "Invalid OTP. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleResendOtp = async () => {
        if (!canResend) return;

        setIsLoading(true);
        setError("");
        setCanResend(false);
        setTimer(59);

        try {
            const response = await forgotPassword(email);
            if (response.success) {
                setSuccess("OTP resent to your email");

                // Restart timer
                const countdown = setInterval(() => {
                    setTimer((prev) => {
                        if (prev <= 1) {
                            clearInterval(countdown);
                            setCanResend(true);
                            return 0;
                        }
                        return prev - 1;
                    });
                }, 1000);
            }
        } catch (error) {
            setError(error.message || "Failed to resend OTP.");
            setCanResend(true);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
        <Navbar {...props} />
        <div className="login-content-info">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-5 col-md-6">
                        <div className="account-content">
                            <div className="account-info">
                                <div className="login-verify-img">
                                    <i className="isax isax-sms" />
                                </div>
                                <div className="login-title">
                                    <h3>Celebrity Email OTP Verification</h3>
                                    <p className="mb-0">
                                        OTP sent to your Email Address ending ******
                                        {email ? email.split('@')[0].slice(-3) + '@' + email.split('@')[1] : ''}
                                    </p>
                                </div>

                                {error && <div className="alert alert-danger">{error}</div>}
                                {success && <div className="alert alert-success">{success}</div>}

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <div className="otp-box">
                                            <InputOtp
                                                value={otp}
                                                onChange={(e) => setOtp(e.value)}
                                                length={6}
                                                integerOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <div className="otp-info">
                                            <div className="otp-code">
                                                <p>
                                                    Didn't receive OTP code?{" "}
                                                    <Link
                                                        to="#"
                                                        onClick={handleResendOtp}
                                                        className={canResend ? "" : "text-muted"}
                                                        style={{ pointerEvents: canResend ? 'auto' : 'none' }}
                                                    >
                                                        Resend Code
                                                    </Link>
                                                </p>
                                            </div>
                                            <div className="otp-sec">
                                                <p>
                                                    <i className="isax isax-clock" />
                                                    {formatTime(timer)} mins
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="reset-btn">
                                        <button
                                            type="submit"
                                            className="btn btn-primary-gradient w-100"
                                            disabled={isLoading || otp.length !== 6}
                                        >
                                            {isLoading ? "Verifying..." : "Verify OTP"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default ResetOtp2;